export const CATEGORY_COLORS = {
    Health: "green",
    Fitness: "blue",
    Productivity: "yellow",
    Mindfulness: "purple",
};